import { Header } from "../../components/header";
import Sidebar from "../../components/sidebar";
import style from "./style.module.scss";
import { Outlet } from "react-router-dom";
import { useState } from "react";

export const MainLayout = () => {
  const [screenStack, setScreenStack] = useState([]);
  const [showSidebar, setShowSidebar] = useState(false);

  return (
    <div className={style.container}>
      <div className={style["sidebar-container"]}>
        <Sidebar
          screenStack={screenStack}
          setScreenStack={setScreenStack}
          onOpenSidebar={() => setShowSidebar(true)}
        />
      </div>
      <div className={style["content-container"]}>
        <Header
          onNavClick={() => setShowSidebar(true)}
          screenStack={screenStack}
        />
        <div className={style["pages-wrapper"]}>
          <Outlet />
        </div>
      </div>
    </div>
  );
};
